var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 7.42439C9.02548 7.42439 7.42489 9.02497 7.42489 10.9994C7.42489 12.9738 9.02548 14.5744 10.9999 14.5744C12.9743 14.5744 14.5749 12.9738 14.5749 10.9994C14.5749 9.02497 12.9743 7.42439 10.9999 7.42439ZM9.0749 10.9994C9.0749 9.93624 9.93675 9.07439 10.9999 9.07439C12.063 9.07439 12.9249 9.93624 12.9249 10.9994C12.9249 12.0625 12.063 12.9244 10.9999 12.9244C9.93675 12.9244 9.0749 12.0625 9.0749 10.9994Z",
    fill: "#37383C",
    fillOpacity: 0.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17.7823C15.1765 17.7823 18.7545 15.2198 20.2476 11.5812C20.4005 11.2084 20.4005 10.79 20.2476 10.4173C18.7545 6.77871 15.1765 4.21619 11 4.21619C6.82346 4.21619 3.24545 6.77871 1.75241 10.4173C1.59946 10.79 1.59946 11.2084 1.75241 11.5812C3.24545 15.2198 6.82346 17.7823 11 17.7823ZM3.29774 10.9992C4.55491 7.9849 7.53002 5.86619 11 5.86619C14.4699 5.86619 17.4451 7.9849 18.7022 10.9992C17.4451 14.0136 14.4699 16.1323 11 16.1323C7.53002 16.1323 4.55491 14.0136 3.29774 10.9992Z",
    fill: "#37383C",
    fillOpacity: 0.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/password_eye.cab8985a3befa89078691538e9d1d96e.svg";
export { ForwardRef as ReactComponent };